import React, { FunctionComponent } from "react";
import {
  Typography,
  Drawer,
  Stack,
  MenuItem,
  Box,
  SvgIcon,
  SelectChangeEvent,
} from "@mui/material";
import { CustomInput } from "../../components/CustomInput";
import { CustomSelect } from "../../components/CustomSelect";
import { CustomDatePicker } from "../../components/CustomDatePicker";
import { Button } from "../Button";
import Icon from "@mdi/react";
import { mdiFilterOutline } from "@mdi/js";
import { isValidDate } from "../../utils/time";
import { DropdownValue } from "../../types/DropdownValue";

type RelationData = {
  paramName: string;
  type: "T" | "D";
  label: string;
  value?: string | DropdownValue[] | null;
  selectedValue: string | Date;
};

type IProps = {
  isOpen: boolean;
  filters: RelationData[];
  values: (Date | string)[];
  onChangeDate: (newValue: any, paramName: string) => void;
  onChangeSelect: (
    event: SelectChangeEvent<unknown>,
    paramName: string
  ) => void;
  onClose?: () => void;
};

export const LegacyReportSidebar: FunctionComponent<IProps> = (props) => {
  return (
    <Drawer
      onClose={props.onClose}
      open={props.isOpen}
      anchor="right"
      PaperProps={{
        sx: {
          width: 290,
          borderTopLeftRadius: 20,
          borderBottomLeftRadius: 20,
          p: 4,
          display: "flex",
          justifyContent: "flex-start",
          flexDirection: "column",
        },
      }}
    >
      <Box borderBottom="1px solid rgba(0, 0, 0, 0.12)" width="100%" pb={4}>
        <Stack alignItems="center" direction="row" spacing={1}>
          <SvgIcon>
            <Icon path={mdiFilterOutline} color="#1BA0E9" />
          </SvgIcon>
          <Typography
            variant="h4"
            sx={{ color: "#1BA0E9", fontWeight: 600, fontSize: 20, mt: 2 }}
          >
            Filters
          </Typography>
        </Stack>
      </Box>
      <Stack direction="column" mt={4} spacing={4}>
        {props.filters.map((filter, index) => {
          if (filter.value === "D") {
            return (
              <CustomDatePicker
                value={filter.selectedValue as Date}
                key={index}
                label={{ text: filter.label }}
                onChange={(newValue) =>
                  props.onChangeDate(newValue, filter.paramName)
                }
              />
            );
          } else if (!Array.isArray(filter.value)) {
            return (
              <CustomInput
                width={150}
                key={index}
                label={{ text: filter.label }}
              />
            );
          } else {
            return (
              <CustomSelect
                value={filter.selectedValue}
                onChange={(event) =>
                  props.onChangeSelect(event, filter.paramName)
                }
                label={filter.label}
                width={150}
                placeholder={filter.label}
                key={index}
              >
                {filter.value.map((item, index) => {
                  return (
                    <MenuItem value={item.id}>{item.description}</MenuItem>
                  );
                })}
              </CustomSelect>
            );
          }
        })}
      </Stack>
    </Drawer>
  );
};
